export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "indicator-trends.7209f9ce88a62878163a.worker.js");
}
